import axiosInstance from "app/axiosInstance";
import { CreateKeysRequestDto } from "../entities/dtos/create-keys-request.dto";

export const postKeys = async ({ accountId, keyIds }: CreateKeysRequestDto) => {
  try {
    const response = await axiosInstance.post(`/accounts/${accountId}/keys`, {
      keyIds
    });

    return response;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
